import * as React from 'react';

export interface LookupButtonProps {
  admin: boolean;
  avochatoRep: boolean;
  subdomain?: string;
}

export const LookupButton = ({ admin, avochatoRep, subdomain }: LookupButtonProps) => {
  if ((admin || avochatoRep) && subdomain) {
    const href = avochatoRep ? `/admin/accounts/${subdomain}` : `/accounts/${subdomain}/tickets`;
    return (
      <a
        href={href}
        className="lookup-button noselect"
        data-role="none"
        data-turbolinks="false"
      >
        
      </a>
    );
  }
  return null;
};
